import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CamService } from 'src/app/services/camService/cam.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';


@Component({
    selector: 'app-successfully-uploaded',
    templateUrl: './successfully-uploaded.component.html',
    styleUrls: ['./successfully-uploaded.component.scss'],
    imports: [MatIconButton, MatIcon, ReactiveFormsModule, FormsModule]
})
export class SuccessfullyUploadedComponent {
  //private _MatDialogRef: any;

constructor(public dialogRef: MatDialogRef<SuccessfullyUploadedComponent>,private _CamService: CamService ) { }

  CloseDialog(): void {
    this.dialogRef.close();
    this._CamService.notifyDialogClosed(true); 

  }

}
